<template>
  <div class="father-module">
    <!-- 数据统计 -->
    <div class="left-box1 flex flex-v">
      <div class="title-module flex flex-pack-justify">
        <img src="@/assets/image/layout/mod-title.png" alt="" class="title-module-img" />
        <div>实时数据统计</div>
        <div class="tabs flex flex-align-center">
          <div class="tab-item" @click="curIndex = 0" :class="{ active: curIndex == 0 }">
            总数据
          </div>
          <div class="tab-item" @click="curIndex = 1" :class="{ active: curIndex == 1 }">
            设施明细
          </div>
        </div>
      </div>
      <div class="flex-1 main-module">
        <template v-if="curIndex == 0">
          <!--在线桥梁-->
          <div class="online flex flex-align-center flex-pack-center">
            <img src="@/assets/image/layout/online.png" />
            <div>
              <div>在线设施</div>
              <div class="num">{{ onLine }}</div>
            </div>
          </div>
          <div class="title-module flex flex-pack-justify">
            <img
              src="@/assets/image/layout/mod-title.png"
              alt=""
              class="title-module-img"
            />
            <div>设备在线情况</div>
          </div>
          <!--设备在线情况-->
          <div class="deviceInfo flex flex-wrap flex-pack-justify">
            <div
              class="device-item"
              v-for="(item, index) in biEquipmentCount"
              :key="index"
            >
              <div class="title">{{ item.name }}</div>
              <div class="flex flex-align-center flex-pack-center">
                <div>
                  <span>在线</span>
                  <span class="num">{{
                    item.name === 'GNSS' ? item.online + item.offline : item.online
                  }}</span>
                </div>
                <div>
                  <span>离线</span>
                  <span class="num num-orange">{{
                    item.name === 'GNSS' ? 0 : item.offline
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="title-module flex flex-pack-justify" v-if="false">
            <img
              src="@/assets/image/layout/mod-title.png"
              alt=""
              class="title-module-img"
            />
            <div class="flex flex-align-center">
              <img class="icon" src="@/assets/image/layout/video.png" alt="" />
              <span>桥梁监控</span>
            </div>
            <a @click="showVideoList()" href="javascript:;" class="more">查看更多</a>
          </div>
          <div class="videolist" v-if="false">
            <div class="video-item" @click="showVideoList()">
              <img src="@/assets/image/layout/demo.jpg" alt="" srcset="" />
              <div class="cover"></div>
              <div class="name">{{ videoInfo.cameraName }}</div>
            </div>
          </div>
        </template>
        <template v-if="curIndex == 1">
          <div v-for="(item, index) in newfacList" :key="index">
            <div class="bridgeName flex flex-align-center">
              <img src="@/assets/image/layout/online.png" alt="" />
              <span>{{ item.bridgeName }}</span>
            </div>
            <div class="deviceInfo flex flex-wrap flex-pack-justify">
              <div
                class="device-item"
                v-for="(devitem, index) in item.biEquipmentCount"
                :key="index"
              >
                <div class="title">{{ devitem.name }}</div>
                <div class="flex flex-align-center flex-pack-center">
                  <div>
                    <span>在线</span>
                    <span class="num">{{
                      devitem.name === 'GNSS'
                        ? devitem.online + devitem.offline
                        : devitem.online
                    }}</span>
                  </div>
                  <div>
                    <span>离线</span>
                    <span class="num num-orange">{{
                      devitem.name === 'GNSS' ? 0 : devitem.offline
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="videolist flex flex-wrap flex-pack-justify" v-if="false">
              <div
                class="video-item video-item-sm"
                :key="subitem"
                @click="showVideoList(videitem.cameraUrl)"
                v-for="(videitem, subitem) in item.biBridgeCameraList"
              >
                <img src="@/assets/image/layout/demo.jpg" alt="" srcset="" />
                <div class="cover"></div>
                <div class="name">{{ videitem.cameraName }}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div
      style="
        position: absolute;
        right: -25px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      "
    >
      <slot name="leftImg"></slot>
    </div>
  </div>
</template>

<script>
import { EleResize } from '@/utils/EleResize';
import * as echarts from 'echarts';

export default {
  name: 'leftBox',
  data() {
    return {
      curIndex: 0,
      deviceList: [
        {
          name: '索力监测'
        },
        {
          name: '应力应变监测'
        },
        {
          name: '挠度监测'
        },
        {
          name: '振动监测'
        },
        {
          name: '温度监测'
        },
        {
          name: '拱顶及桥墩位移监测'
        },
        {
          name: '桥墩位移监测'
        }
      ],
      newfacList: []
    };
  },
  props: {
    anjuan: {
      type: Number,
      default: []
    },
    zaixian: {
      type: Number,
      default: []
    },
    facList: {
      type: Array,
      default: () => {}
    }
  },
  watch: {
    facList: {
      handler(newVal, oldVal) {
        let orderArr = [
          { type: 'GNSS', order: 1 },
          { type: '表面应变', order: 2 },
          { type: '桥面线形', order: 3 },
          { type: '索力加速度', order: 4 },
          { type: '振动加速度', order: 5 },
          { type: '环境温湿度', order: 6 },
          { type: '激光测距', order: 7 },
          { type: '风速仪', order: 8 },
          { type: '拉线位移计', order: 9 }
        ];
        this.facList.forEach((item) => {
          let biEquipmentList = item.biEquipmentList;
          let obj = {};
          console.log(
            '%c [ biEquipmentList ]-207',
            'font-size:13px; background:pink; color:#bf2c9f;',
            biEquipmentList
          );
          biEquipmentList.forEach((eqitem) => {
            console.log(
              '%c [ eqitem ]-152',
              'font-size:13px; background:pink; color:#bf2c9f;',
              eqitem
            );
            if (!obj[eqitem.equipmentTypeUuid]) {
              obj[eqitem.equipmentTypeUuid] = {
                name: eqitem.equipmentTypeName,
                id: eqitem.equipmentTypeUuid,
                online: 0,
                offline: 0
              };
            }
            let tt = orderArr.find((item) => item.type === eqitem.equipmentTypeName);
            console.log(
              '%c [ tt ]-161',
              'font-size:13px; background:pink; color:#bf2c9f;',
              tt
            );
            obj[eqitem.equipmentTypeUuid].order = tt.order;
            if (eqitem.status) {
              obj[eqitem.equipmentTypeUuid].online++;
            } else {
              obj[eqitem.equipmentTypeUuid].offline++;
            }
          });
          let biEquipmentCount = Object.values(obj);
          biEquipmentCount.sort((a, b) => {
            return a.order - b.order;
          });
          item.biEquipmentCount = biEquipmentCount;
        });
        this.newfacList = [...this.facList];
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    onLine() {
      return this.facList.filter(e => e.isIot).length;
    },
    videoInfo() {
      for (var i = 0; i < this.facList.length; i++) {
        if (
          this.facList[i].biBridgeCameraList &&
          this.facList[i].biBridgeCameraList.length > 0
        ) {
          return this.facList[i].biBridgeCameraList[0];
        }
      }
      return {};
    },
    biEquipmentCount() {
      let obj = {};
      this.newfacList.forEach((item) => {
        item.biEquipmentCount.forEach((eqitem) => {
          if (!obj[eqitem.id]) {
            obj[eqitem.id] = {
              ...eqitem
            };
          } else {
            obj[eqitem.id].offline += eqitem.offline;
            obj[eqitem.id].online += eqitem.online;
          }
        });
      });
      return Object.values(obj).sort((a, b) => {
        return a.order - b.order;
      });
    }
  },
  mounted() {},

  methods: {
    showVideoList(cameraUrl) {
      this.$emit('showVideoList', cameraUrl || this.videoInfo.cameraUrl);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.left-box1 {
  height: 100%;

  .main-module {
    overflow: auto;
    min-height: 0;
    padding-bottom: 20px;
    margin: 0 -22px;

    & > div {
      margin-left: 22px;
      margin-right: 22px;
    }
  }
}

.tabs {
  background: #013f86;
  border-radius: 6px;
  height: 30px;
  overflow: hidden;
  position: relative;
  z-index: 99;
  margin-top: 22px;

  .tab-item {
    height: 30px;
    line-height: 30px;
    min-width: 70px;
    font-size: 14px;
    padding: 0 7px;
    color: #fff;
    letter-spacing: 0;
    cursor: pointer;

    &.active {
      background: linear-gradient(180deg, #00e5f2 0%, #0158f1 100%);
    }
  }
}

.online {
  padding: 40px 0 33px;
  color: #fff;
  text-align: left;
  font-weight: 800;
  font-size: 18px;

  img {
    width: 69px;
    height: 74px;
    margin-right: 20px;
  }

  .num {
    margin-top: 3px;
    background: linear-gradient(
      90deg,
      rgba(22, 222, 241, 0.5) 0%,
      rgba(128, 128, 128, 0) 100%
    );
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    padding-left: 10px;
    width: 88px;
  }
}

.deviceInfo {
  font-size: 12px;
  color: #ffffff;
  margin: 40px 0 0;

  .device-item {
    width: 150px;
    margin: 0 0 12px;
    padding-bottom: 10px;
    background: linear-gradient(
      134deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(84, 84, 84, 0.2) 100%
    );
    border-radius: 6px 6px 0px 0px;
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 150px;
      height: 2px;
      position: absolute;
      bottom: 0;
      left: 0;
      background: linear-gradient(90deg, #1a78fa 0%, rgba(28, 122, 250, 0) 100%);
    }
  }

  .title {
    min-width: 97px;
    padding: 0 10px;
    max-width: 150px;
    height: 24px;
    background: linear-gradient(130deg, #1054ff 0%, #2d8bd1 100%);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 0px 0px 8px 8px;
    font-size: 14px;
    margin: 0 auto 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .num {
    color: #56e8ed;
    font-weight: bold;
    font-size: 20px;
  }

  .num-orange {
    color: #fdaa2a;
  }
}

.bridgeName {
  font-weight: 800;
  font-size: 20px;
  color: #f4faff;

  img {
    width: 48px;
    height: 52px;
    margin-right: 14px;
  }
}

.videolist {
  margin-top: 12px;

  .video-item {
    width: 100%;
    height: 180px;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    .cover {
      content: '';
      display: block;
      width: 38px;
      height: 38px;
      background: url('~@/assets/image/layout/play.png');
      background-size: 100% 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .name {
      color: #fff;
      position: absolute;
      font-size: 14px;
      left: 13px;
      bottom: 7px;
    }

    &.video-item-sm {
      width: calc(50% - 10px);
      height: 84px;

      .name {
        font-size: 12px;
      }

      .cover {
        width: 21px;
        height: 21px;
      }
    }
  }
}
</style>
